// extracted by css-extract-rspack-plugin
export default {"spinnerSlot":"pnbbcVpaFGcThk7j","radios":"iUS9ou8lNApGoGQM","radio":"yHT7fnZ2BN4Ypmh3","indicator":"sC3mpU6E_c3gZsVR","label":"rqsD8wUikA8py6Qk","items":"dr73neRjyjA9qllN"};